import { createContext } from 'react';
import { OverAllPolicyType } from '../../utils/types';

export const OverAllPolicyTypeContext = createContext<OverAllPolicyType>(
  OverAllPolicyType.ATP
);

export interface PolicyManualScanRunningQueue {
  [key: string]: any;
}
